import { AssetPathResolverService, ConsoleService, ContentService, HrefResolverService, ServicePathProviderService, SiteContextResolverService, WindowTransformerService, } from '@blk/cwp-app-container-utils';
import { compareBasketSelector, environmentSiteContext } from '../../const/constants';
const DIGITAL_WEALTH_WEB_COMPARE_BASKET = 'digital-wealth-web-compare-basket';
const COMPARE_BASKET = compareBasketSelector;
export class CwpSetup {
    constructor(environment = {}) {
        const consoleService = new ConsoleService();
        this.siteContextResolverServiceInstance = new SiteContextResolverService(environmentSiteContext);
        this.windowTransformerInstance = new WindowTransformerService();
        this.siteContextResolverServiceInstance.setContext(this.windowTransformerInstance.getContext(window, environment));
        this.hrefResolverInstance = new HrefResolverService(consoleService);
        this.assetPathResolverInstance = new AssetPathResolverService();
        this.windowTransformerInstance.setupCwpServices(this.hrefResolverInstance, this.assetPathResolverInstance, new ServicePathProviderService(consoleService), window, environment);
        // the selectors which are used by the basket component:
        // digital-wealth-web-compare-basket (old) / compare-basket (new)
        if (document.querySelector(COMPARE_BASKET)) {
            this.contentServiceInstance = new ContentService(COMPARE_BASKET);
        }
        else {
            this.contentServiceInstance = new ContentService(DIGITAL_WEALTH_WEB_COMPARE_BASKET);
        }
    }
    getServiceInstances() {
        return {
            hrefResolver: this.hrefResolverInstance,
            contentService: this.contentServiceInstance,
            assetPathResolver: this.assetPathResolverInstance,
            siteContextResolverService: this.siteContextResolverServiceInstance,
            windowTransformer: this.windowTransformerInstance,
        };
    }
}
